import { render, staticRenderFns } from "./HYGB3.vue?vue&type=template&id=19f2befb"
import script from "./HYGB3.vue?vue&type=script&lang=js"
export * from "./HYGB3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports